"use strict";
// Copyright (c) StrangeBee 2024
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const ParentController_1 = __importDefault(require("../ParentController"));
class TaskLogController extends ParentController_1.default {
    constructor() {
        super(...arguments);
        this.endpoints = {
            create: '/v1/task/:objectId/log',
            edit: '/v1/log/:objectId',
            delete: '/v1/log/:objectId',
            createAttachments: '/v1/log/:objectId/attachments',
            deleteAttachments: '/v1/log/:logId/attachments/:objectId',
            download: '/v1/log/:logId/attachment/:attachmentId',
        };
    }
    download(logId, attachmentId) {
        return this.manager.get({
            url: this.endpoints.download,
            params: {
                logId,
                attachmentId,
            },
        });
    }
    create(taskLog, objectId) {
        const { message, attachments, includeInTimeline } = taskLog;
        const formData = new FormData();
        formData.set('_json', JSON.stringify({ message, includeInTimeline }));
        if (attachments && attachments.length) {
            attachments.forEach((attachment) => {
                formData.append('attachments', attachment);
            });
        }
        return this.manager.post({
            url: this.endpoints.create,
            params: { objectId },
        }, formData);
    }
    multiEdit(taskLog, objectId) {
        const { message, attachments, attachmentsRemoved, includeInTimeline } = taskLog;
        const runPromise = [];
        if (message || typeof includeInTimeline !== undefined) {
            runPromise.push(this.edit({ message, includeInTimeline }, objectId));
        }
        if (attachments && attachments.length) {
            runPromise.push(this.createAttachments(attachments, objectId));
        }
        if (attachmentsRemoved) {
            attachmentsRemoved.forEach((attachmentId) => {
                runPromise.push(this.deleteAttachments(objectId, attachmentId));
            });
        }
        return Promise.all(runPromise);
    }
    createAttachments(attachments, objectId) {
        const formData = new FormData();
        if (attachments && attachments.length) {
            attachments.forEach((attachment) => {
                formData.append('attachments', attachment);
            });
        }
        return this.manager.post({
            url: this.endpoints.createAttachments,
            params: { objectId },
        }, formData);
    }
    deleteAttachments(logId, objectId) {
        return this.manager.delete({
            url: this.endpoints.deleteAttachments,
            params: { logId, objectId },
        });
    }
}
exports.default = TaskLogController;
